import React, { useCallback, useMemo } from 'react';
import { useQueryClient } from 'react-query';
import { useParams } from 'react-router';
import getName from '../../../../../../helpers/getName';
import DescriptionPictures from '../../../../components/DescriptionPictures/DescriptionPictures';
import queries from '../../../../queries/queries';
import styles from './AboutFacility.module.scss';
import Parameter from '../../../../components/Parameter/Parameter';
import useCompanyServicesUsed from '../../../../hooks/useCompanyservicesUsed';
import useParameterTextWithArea from '../../../../hooks/useParameterText';

const AboutFacility = ({ facility }) => {
  const queryClient = useQueryClient();

  const { facilityId } = useParams();

  const companyServices = useCompanyServicesUsed(facility);

  const updateFacility = useCallback(
    () => queryClient.invalidateQueries([queries.facility, facilityId]),
    [facilityId]
  );

  const totalAreaText = useParameterTextWithArea(facility.totalArea);
  const areaForRentText = useParameterTextWithArea(facility.areaForRent);
  const mopAreaText = useParameterTextWithArea(facility.mopArea);
  const officesMopAreaText = useParameterTextWithArea(
    facility.officesMopArea
  );

  return (
    <div className={styles.aboutFacilityLayout}>
      <div className={styles.content}>
        <div className={styles.parameters}>
          <Parameter
            title="Номер"
            text={facility.number || '-'}
            className={styles.number}
          />
          <Parameter
            title="Общая площадь"
            text={totalAreaText}
            className={styles.totalArea}
          />
          <Parameter
            title="Площадь под сдачу"
            text={areaForRentText}
            className={styles.areaForRent}
          />
          <Parameter
            title="Площадь МОП"
            text={mopAreaText}
            className={styles.mopArea}
          />
          <Parameter
            title="Площадь помещений с МОП"
            text={officesMopAreaText}
            className={styles.officesMopArea}
          />
          <Parameter
            title="Признаки для отображения в квитанции"
            text={!companyServices.length && '-'}
            list={companyServices.length > 0 && companyServices}
            className={styles.marks}
          />
          <Parameter
            title="Количество помещений"
            text={facility.officesAmount || '-'}
            className={styles.amountRooms}
          />
          <Parameter
            title="Брокер"
            text={(facility.broker && getName(facility.broker)) || '-'}
            className={styles.broker}
          />
          <Parameter
            title="Управляющий"
            text={(facility.manager && getName(facility.manager)) || '-'}
            className={styles.manager}
          />
        </div>
        <div className={styles.descAndCommentWrapper}>
          <Parameter
            title="Описание"
            text={facility.description?.description || '-'}
            addBackground
            className={styles.descAndComment}
          />
          <Parameter
            title="Комментарий"
            text={facility.comment || '-'}
            addBackground
            className={styles.descAndComment}
          />
        </div>
      </div>
      <div className={styles.gallery}>
        <DescriptionPictures
          onUpdate={updateFacility}
          attachments={facility.description?.attachments}
          descriptionId={facility.description?.id}
        />
      </div>
    </div>
  );
};

export default AboutFacility;
